import {FC} from "react";
import TextParser from "@/pages/Root/components/TextParser/TextParser";
import PublisherLogo from "../PublisherLogo/PublisherLogo";
import { StorySize } from '@/moment/types/story-types';
import "./ProductCard.scss";
import {ProductPurchase} from "@moment/net/softbox-types.ts";
import Currency from "@moment/components/Currency/Currency.tsx";
import {Button} from "@moment/components/Button/Button.tsx";
import {resolvedLanguage} from "@/i18n.ts";

interface ProductCardProps {
  title?: string;
  summary?: string;
  isIgnoreParagraphInDescription?: boolean;
  brand: string;
  isDark?: boolean;
  product: ProductPurchase;
  sourceLink: string;
};

const ProductCard: FC<ProductCardProps> = ({title, summary, isIgnoreParagraphInDescription=false, brand, isDark, product, sourceLink}) => {
  const lang = resolvedLanguage('en');
  const handleClick = () => {
    window.open(sourceLink, '_blank');
  }
  return (
    <div className="card" data-testid="test-card">
      { brand ? <div>{brand}</div> : '' }
      { product ? <div className="card-product-cta">
                    <Currency currencyCode={product.currency} locale={'en-US'} amount={product.price} className='card-product-price'/>
                    <div className="card-product-cta-btn">
                      <Button className="card-product-button" label={product.cta[lang] || 'en'} onClick={handleClick} />
                    </div>
                  </div> : ''}
      { title ? <h2 className="card-title title-lg">{title}</h2> : '' }
      { summary ? <div className="card-summary body-md">
                  <TextParser
                    text={summary}
                    option={{ isIgnoreParagraph: isIgnoreParagraphInDescription, useJsx: true }}
                  /></div> : ''}
    </div>
  );
};

export default ProductCard;
